import { useCallback, useState } from 'react'
import { useLoading } from 'shared/hooks'
import { useGetChartsByNameLazyQuery } from 'modulesCommon/graphql/queries/getChartsByName.types'
import * as Types from 'shared/__gql-types'
import { getResultData } from 'modules/ProjectEdit/helpers'
import { TAutoCompleteOption } from 'shared/types/SelectOptions'

export const useChartSearch = () => {
  const [chartResult, setChartResult] = useState<TAutoCompleteOption[]>([])
  const [getChartsByName, { loading: chartLoading }] = useGetChartsByNameLazyQuery()

  const searchChartHandler = useCallback(
    async (type: Types.ChartNameTypeParameter, name: string) => {
      const { data } = await getChartsByName({ variables: { type, name } })
      setChartResult(getResultData(type === 'artist' ? type : 'title', data?.getChartsByName ?? []))
    },
    [getChartsByName, setChartResult]
  )

  useLoading({ isLoading: chartLoading })

  return {
    isLoading: chartLoading,
    searchChartHandler,
    chartResult
  }
}
